<template>
  <v-dialog v-model="open" scrollable max-width="300px">
    <edit-post-menu-list
      :initCid="initCid"
      :initMembers="initMembers"
      :talkShare="talkShare"
      :includeEvent="includeEvent"
      @menuSelected="onMenuSelected"
      @eventSelected="$emit('eventSelected')"
    />
  </v-dialog>
</template>

<script>
import editPostMenuList from './EditPostMenuList';

export default {
  components: {
    'edit-post-menu-list': editPostMenuList,
  },
  props: ['value', 'initCid', 'initMembers', 'talkShare', 'includeEvent'],
  data() {
    return {
      open: this.value,
    };
  },
  watch: {
    value(n, o) {
      this.open = n;
    },
    open(n, o) {
      this.$emit('input', n);
    },
  },
  methods: {
    onMenuSelected() {
      this.open = false;
    },
  },
};
</script>
